export const categories = [
  {
    slug: "yule-xingwen",
    name: "娱乐星闻",
    desc: "艺人与作品相关的公开动态整理，只看台前，不挖私域。",
    icon: "ri-star-smile-line",
    count: 186,
  },
  {
    slug: "zongyi-xianchang",
    name: "综艺现场",
    desc: "节目录制花絮、名场面复盘与播出后的讨论沉淀。",
    icon: "ri-mic-line",
    count: 142,
  },
  {
    slug: "yingshi-rebo",
    name: "影视热播",
    desc: "剧集与影片的更新节奏、路透整理和角色讨论。",
    icon: "ri-film-line",
    count: 205,
  },
  {
    slug: "yinyue-xianchang",
    name: "音乐现场",
    desc: "巡演、音乐节与舞台现场的观演记录与片段汇总。",
    icon: "ri-music-2-line",
    count: 97,
  },
  {
    slug: "wanghong-huati",
    name: "网红话题",
    desc: "内容创作者公开事件的时间线与各方回应梳理。",
    icon: "ri-live-line",
    count: 163,
  },
  {
    slug: "wangluo-rengeng",
    name: "网络热梗",
    desc: "这一周被反复二创的口头禅、表情与名场面出处。",
    icon: "ri-emotion-laugh-line",
    count: 74,
  },
];

export const siteInfo = {
  name: "吃瓜前线",
  slogan: "一眼看懂今天的热点",
  intro:
    "吃瓜前线是一个聚焦娱乐圈与网络热点话题的中文资讯门户，把碎片化的现场直播、秒删截图与实时楼内容重新梳理成清晰的时间线，让每个热点都能被完整读懂。",
  email: "hello@chiguaqianxian.example.com",
  tipEmail: "tips@chiguaqianxian.example.com",
  since: "2023",
};